// OPCRegistration.jsx
import React from "react";

export default function OPCRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for One Person Company (OPC) Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            One Person Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            One Person Company (OPC) Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists entrepreneurs in OPC Registration,
            providing a corporate structure with limited liability for single
            owners while ensuring proper legal recognition and compliance with
            relevant company law provisions.
          </p>
          <p className="text-gray-700">
            From obtaining essential approvals to completing incorporation
            filings, the team supports single founders in forming an OPC so they
            can enjoy the benefits of a private company structure while
            retaining full operational control.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Consultation for OPC registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for OPC Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps the owner and nominee organize and
              verify all documents needed for OPC incorporation, reducing the
              risk of queries and delays during company registration.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card and address proof of the owner</li>
                <li>Identity and address proof of the nominee</li>
                <li>Nominee consent and declaration, as applicable</li>
                <li>
                  Proof of registered office (rent agreement, utility bill, NOC
                  from owner, etc.)
                </li>
                <li>Digital Signature Certificate (DSC) of the proposed director</li>
                <li>Director Identification Number (DIN) details or application</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm brings focused expertise in OPC structures, ensuring that
              single-owner companies are incorporated accurately and remain
              compliant with MCA requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  OPC-Specific Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance tailored to OPC models, including eligibility,
                  nominee appointment, and structuring share capital for a
                  single-owner company.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate MCA Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in preparing forms and documents as per Ministry of
                  Corporate Affairs requirements to avoid rejections and ensure
                  smooth approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Incorporation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance from document collection and drafting to filing
                  incorporation applications and receiving the Certificate of
                  Incorporation for the OPC.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
